// extracted by mini-css-extract-plugin
export default {"imageSpinner":"spinnerInner_imageSpinner__0wNrO","rotate":"spinnerInner_rotate__avJJr","prixClipFix":"spinnerInner_prixClipFix__BjRNz"};